<template>
  <div class="emh-side-filters-price-category">
    <ui-button-group-tab-view
      :tabs="priceTypeOptions"
      :disabled="isLoading"
      group-name="price-type"
      manage-tab-selection
      data-test-id="emh-side-filters-price-category__tabs"
      @clear-category="onClearCategory(filter)"
    >
      <template #[priceTypeCodes.priceValue]>
        <emh-side-filters-range-dropdowns
          :filter="priceFilter"
          :is-loading="isLoading"
          format-currency-labels
          data-test-id="emh-side-filters-price-category__price-range"
          @change="onChangeFilterValue"
        />
      </template>

      <template #[priceTypeCodes.monthlyRate]>
        <emh-side-filters-range-dropdowns
          :filter="monthlyRateFilter"
          :is-loading="isLoading"
          format-currency-labels
          data-test-id="emh-side-filters-price-category__monthly-rate-range"
          @change="onChangeFilterValue"
        />
      </template>
    </ui-button-group-tab-view>
  </div>
</template>

<script lang="ts">
export default {
  name: 'EmhSideFiltersPriceCategory',
};
</script>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import { findFilterByCode } from '../../../utils/helpers';
import UiButtonGroupTabView from '@dh-io-emh/ui/src/form/buttonGroup/buttonGroupTabView/ButtonGroupTabView.vue';
import { ButtonGroupTabView } from '@dh-io-emh/ui/src/form/buttonGroup/buttonGroupTabView/button-group-tab-view.model';
import ProductFilterPriceSlider from '@dh-io-emh/shared/src/models/product-filter/product-filter-price-slider.model';
import EmhSideFiltersRangeDropdowns from '../../sideFiltersRangeDropdowns/SideFiltersRangeDropdowns.vue';
import {
  FilterCode,
  IProductFilterField,
  IProductFilterGroup,
} from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';

const priceTypeCodes = {
  priceValue: FilterCode.priceValue,
  monthlyRate: FilterCode.monthlyRate,
};

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
  filterCategory: {
    type: Object as PropType<IProductFilterGroup>,
    required: true,
  },
});

const emit = defineEmits(['change', 'clear-category']);

const { filterCategory } = toRefs(props);

const priceFilter = computed(
  () => findFilterByCode(filterCategory.value.filters, FilterCode.priceValue) as ProductFilterPriceSlider,
);

const monthlyRateFilter = computed(
  () => findFilterByCode(filterCategory.value.filters, FilterCode.monthlyRate) as ProductFilterPriceSlider,
);

const priceTypeOptions = computed<ButtonGroupTabView[]>(() => {
  const basePriceTypeOptions: ButtonGroupTabView[] = [];

  if (priceFilter.value) {
    basePriceTypeOptions.push({
      label: priceFilter.value.name,
      value: FilterCode.priceValue,
    });
  }

  if (monthlyRateFilter.value) {
    basePriceTypeOptions.push({
      label: monthlyRateFilter.value.name,
      value: FilterCode.monthlyRate,
    });
  }

  return basePriceTypeOptions;
});

const onChangeFilterValue = (filterValue: Partial<IProductFilterField>) => emit('change', filterValue);

const onClearCategory = (filterOption) => emit('clear-category', [filterOption.code]);
</script>
